import { throttle } from "lodash";
import { useEffect } from "react";

type TInfinite = {
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  ref: React.MutableRefObject<HTMLDivElement | null>;
  totalPages: number;
  getData?: (value: number) => void;
  selectWeddingLocaionFilter?: {
    location_1: string;
    location_2?: string;
    selected: boolean;
  }[];
  selectWeddingFilter?: number[];
};
function useInfiniteScroll({
  page,
  setPage,
  ref,
  totalPages,
  selectWeddingLocaionFilter,
  selectWeddingFilter,
}: TInfinite) {
  useEffect(() => {
    const onIntersect = throttle(([entry]) => {
      if (entry.isIntersecting && page <= totalPages) {
        setPage(page + 1);
      }
    }, 500);

    const options = {
      root: null,
      rootMargin: "20px",
      threshold: 0.8,
    };

    let observer: IntersectionObserver;
    if (ref?.current) {
      observer = new IntersectionObserver(onIntersect, options);
      setTimeout(() => {
        if (ref.current) {
          observer?.observe(ref.current);
        }
      }, 1000);
    }

    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [
    setPage,
    ref?.current,
    page,
    selectWeddingLocaionFilter,
    selectWeddingFilter,
  ]);
}

export default useInfiniteScroll;
